export const inputsMaxLengths = {
  id: 10,
  username: 50,
  firstname: 30,
  lastname: 30,
  oht: 50,
  outOfTreatmentReason: 128,
};
